import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store";
import Home from "./components/Home";
import Email from "./components/Email";
import Account from "./components/Account";
import Developer from "./components/Developer";
import Settings from "./components/Settings";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/account",
      name: "account",
      component: Account
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings
    },
    {
      path: "/email",
      name: "BCC",
      component: Email
    },
    {
      path: "/dev",
      name: "dev",
      component: Developer
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
});

router.beforeResolve((to, from, next) => {
  if (to.name === "account" || to.name === "dev" || to.name === "BCC") next();
  else {
    // setTimeout(() => {
      if (store.getters.user.email) {
        next();
      } else {
        next({ name: "account" });
      }

  }
});

export default router;
